const Select = ({ data, selectValue, setSelectValue, name,backgroundColor='bg-gray-50', focusRing = 'focus:ring-cyan-600' , focusBorder = 'border-cyan-600' , textColor = 'text-gray-900', focusOutline, border='border' }) => {
    return (
        <div className="w-full">
            <select
                value={selectValue || ""}  // Use selectValue to show the selected value
                onChange={(e) => setSelectValue(name, e.target.value)}  // Pass the name and value
                className={`shadow-sm ${backgroundColor} ${textColor} ${border} border-gray-300 text-gray-900 sm:text-sm rounded-lg ${focusOutline} ${focusRing} ${focusBorder} block w-full p-3`}
            >
                <option value="" disabled>
                    Please select the option
                </option>

                {data?.map((item, index) => (
                    <option key={index} value={item?.value}>
                        {item?.name}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default Select;
